import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
	selector: 'app-hire-recruiter',
	templateUrl: './hire-recruiter.component.html',
	styleUrls: ['./hire-recruiter.component.scss']
})
export class HireRecruiterComponent {
	dropdownList = [];
	//below settings are configured in ngOnInit.
	dropdownSettings: IDropdownSettings = {};
	public getEmpData: any[] = [];
	public dialogForm!: FormGroup
	constructor(private spinner: NgxSpinnerService, private userManagementService: UserManagementService, private fb: FormBuilder,
		public dialogRef: MatDialogRef<HireRecruiterComponent>, private appService: AppService,private recruiterService:RecruiterService) { }
	ngOnInit(): void {
		//Called after the constructor, initializing input properties, and the first call to ngOnChanges.
		//Add 'implements OnInit' to the class.
		this.dropdownSettings = {
			idField: 'em_i',
			textField: 'first_name',
			// below setting will help to enable search filter in multi select dropdown
			allowSearchFilter: true
		};
		this.getRecruiterEmployeesList("");
		this.dialogForm = this.fb.group({
			'recruiter': ["", Validators.required]
		})
	}
	getRecruiterEmployeesList(value: any) {
		this.spinner.show()
		this.getEmpData = []
		let data = {
			employee: "",
			recruiter: "yes"
		}
		this.userManagementService.sendInvitationRecruiter(data).subscribe((success: any) => {
			this.spinner.hide();
			if (success.status == 200) {
				this.getEmpData = success.msg.employee_list
				for (let i = 0; i < this.getEmpData.length; i++) {
					if (this.getEmpData[i].last_name) {
						this.getEmpData[i].first_name = this.getEmpData[i].first_name + ' ' + this.getEmpData[i].last_name
					}
				}
			}
		})
	}
	isControlHasError(controlName: string, validationType: string,): boolean {
		return this.appService.isControlHasError(this.dialogForm, controlName, validationType)
	}
	onSubmit() {
		if (this.dialogForm.invalid) {
			this.dialogForm.markAllAsTouched()
			return;
		}
		if (!this.dialogForm.invalid) {
			let array:any[] = []
			for (let i = 0; i < (this.dialogForm.value.recruiter).length; i++) {
				let id:any=this.dialogForm.value.recruiter[i]["em_i"]
				array.push(id)
			}
			let data: any = {
				em_i: array,
				type: "recruiter"
			}
			this.spinner.show();
			this.recruiterService.inviteRecruiter(data).subscribe((success: any) => {
				this.spinner.hide();
				// this.successToast(success.msg);
				if (success.status == 200) {
					// this.reset();
					this.appService.showToastMessage('success', success.msg)
					this.dialogRef.close(true); // Keep only this row
					// if(this.data["type"]=="recruiter"){

					// }
					// else{
					// 	this.router.navigateByUrl('job-invite');
					// }

				}
			},);
		}
	}
	onCancel() {
		this.dialogRef.close()
	}
}
